<script setup>
  defineProps({
    /**
     * 興行収入の<b>点推定</b>（{ value, unit } 形式）。
     * 従来は区間の上端（max）を単独表示していたが、それは点推定の +10% に当たるため
     * 実績と比べて約一割高く出ていた。表示は点推定に統一する（DEV-14802）。
     */
    formattedRevenue: { type: Object, default: () => ({ value: 0, unit: '' }) },
  });
</script>
<template>
  <div class="revenue-range">
      <span class="revenue-max">{{ formattedRevenue.value }}<span style="font-size:1.5rem">{{ formattedRevenue.unit }}円</span></span>
  </div>
  <div class="sub-stat" style="margin-top:10px;">
      <i class="fas fa-robot"></i> AI Prediction Model v2.5
  </div>
</template>
